import {
  activateClipboardForSelector,
  activateDelegatedTooltips,
  scrollToPageBottom
} from "./utils"
import $ from "jquery"
import _ from "lodash"
import idle from "./vendor/idle"
import { applyToAllLogTimestamps } from "./logs";
import { timestampNsToAgo } from "./formatters";

let hooks = {}

hooks.SourceSchemaModalTable = {
  mounted() {
    activateClipboardForSelector(`.${this.el.classList} .copy-metadata-field`, {
      container: document.getElementById("logflare-modal"),
    })
    $(".copy-metadata-field").tooltip()
  },
}

hooks.SourceLogsSearchList = {
  captureScrollAnchor() {
    const firstVisibleLogEvent = [...this.el.querySelectorAll("#logs-list > li[data-event-id]")]
      .find((element) => {
        const { top, bottom } = element.getBoundingClientRect()
        return top < window.innerHeight && bottom > 0
      })

    this.scrollAnchor = firstVisibleLogEvent?.id
      ? {
        id: firstVisibleLogEvent.id,
        top: firstVisibleLogEvent.getBoundingClientRect().top,
      }
      : null
  },
  restoreScrollAnchor() {
    const scrollAnchor = this.scrollAnchor

    if (!scrollAnchor) return

    const anchorElement = document.getElementById(scrollAnchor.id)

    if (!anchorElement || !this.el.contains(anchorElement)) return

    const scrollDelta = anchorElement.getBoundingClientRect().top - scrollAnchor.top

    if (scrollDelta !== 0) window.scrollBy(0, scrollDelta)
  },
  flushScrollToBottom() {
    requestAnimationFrame(() => {
      if (!this.pendingScrollToBottom) return

      this.pendingScrollToBottom = false
      scrollToPageBottom()
    })
  },
  beforeUpdate() {
    this.captureScrollAnchor()
  },
  updated() {
    const hook = this
    activateDelegatedTooltips(this.el, '[data-toggle="tooltip"]')

    if (this.pendingScrollToBottom) {
      this.flushScrollToBottom()
    } else {
      this.restoreScrollAnchor()
    }

    const observer =
      new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          let searchInView = entry.isIntersecting
          if (searchInView) {
            // play when we scroll down
            // hook.pushEvent("soft_play", {})
          } else {
            // pause when we scroll up
            hook.pushEvent("soft_pause", {})
          }
        })
      })

    const target = document.querySelector("#observer-target")
    observer.observe(target)
  },
  mounted() {
    activateDelegatedTooltips(this.el, '[data-toggle="tooltip"]')
    this.pendingScrollToBottom = false
    this.handleEvent("scroll-to-bottom", () => {
      this.pendingScrollToBottom = true
      this.flushScrollToBottom()
    })
  },
  destroyed() {
    $(this.el).tooltip("dispose")
  },
}

hooks.ModalHook = {
  mounted() {
    const $modal = $(this.el)

    if ($modal.data("modal-type") === "metadata-modal") {
      this.pushEvent("soft_pause", {})
    }

    $modal.on("hidePrevented.bs.modal", () => {
      this.pushEvent("deactivate_modal", {})

      if ($modal.data("modal-type") === "metadata-modal") {
        this.pushEvent("soft_play", {})
      }
    })

    $modal.modal({
      backdrop: "static"
    })
  },
  destroyed() {
    const $body = $("body")
    $(".modal").modal("dispose")
    $body.removeClass("modal-open")
    $body.removeAttr("style")
    $(".modal-backdrop").remove()
  },
}

const datepickerConfig = {
  showDropdowns: true,
  timePicker: true,
  timePicker24Hour: true,
  drops: "up",
  alwaysShowCalendars: true,
  ranges: {
    Today: [],
    Yesterday: [],
    "Last 15 Minutes": [],
    "Last 7 Days": [],
    "This Month": [],
    "Last Month": [],
  },
}

const buildTsClause = (start, end, label) => {
  let timestampFilter
  const formatWithISO8601 = (x) => x.format("YYYY-MM-DDTHH:mm:ss")
  switch (label) {
    case "Today":
      timestampFilter = ["t:today"]
      break
    case "Yesterday":
      timestampFilter = ["t:yesterday"]
      break
    case "Last 15 Minutes":
      timestampFilter = ["t:last@15m"]
      break
    case "Last 7 Days":
      timestampFilter = ["t:last@7d"]
      break
    case "This Month":
      timestampFilter = ["t:this@month"]
      break
    case "Last Month":
      timestampFilter = ["t:last@month"]
      break
    default:
      timestampFilter = [
        `t:${formatWithISO8601(start)}..${formatWithISO8601(end)}`,
      ]
      break
  }
  return timestampFilter.join(" ")
}

hooks.SourceLogsSearch = {
  configureDateRangePicker() {
    const hook = this
    const $daterangepicker = $("#daterangepicker")

    $daterangepicker.daterangepicker(datepickerConfig)
    $daterangepicker.off(".sourceLogsSearch")

    $daterangepicker.on("apply.daterangepicker.sourceLogsSearch", (e, picker) => {
      const tsClause = buildTsClause(
        picker.startDate,
        picker.endDate,
        picker.chosenLabel
      )
      hook.pushEvent("datetime_update", {
        querystring: tsClause
      })
    })

    $daterangepicker.on("cancel.daterangepicker.sourceLogsSearch", () => {
      hook.pushEvent("soft_play", {})
    })

    $daterangepicker.on("show.daterangepicker.sourceLogsSearch", () => {
      hook.pushEvent("soft_pause", {})
    })
  },
  pushChartControlsUpdate() {
    const chartPeriod = this.el.querySelector("#search_chart_period")?.value
    const chartAggregate = this.el.querySelector("#search_chart_aggregate")?.value

    if (!chartPeriod || !chartAggregate) {
      return
    }

    this.pushEvent("chart_controls_update", {
      chart_period: chartPeriod,
      chart_aggregate: chartAggregate,
    })
  },
  updated() {
    this.configureDateRangePicker()

    activateClipboardForSelector("#search-uri-query", {
      text: () => location.href,
    })
    $("#search-uri-query").tooltip()
  },
  reconnected() { },
  mounted() {
    const hook = this
    this._handleSearchControlChange = (event) => {
      if (
        event.target.id === "search_chart_period" ||
        event.target.id === "search_chart_aggregate"
      ) {
        this.pushChartControlsUpdate()
      }
    }
    this._handleSearchControlKeydown = (event) => {
      if (
        event.key !== "Enter" ||
        event.isComposing ||
        !event.target.matches('#recommended_fields input[name^="fields["]')
      ) {
        return
      }

      const editorHook = this.el.querySelector("#lql-editor-hook")

      if (!editorHook) {
        return
      }

      event.preventDefault()
      editorHook.dispatchEvent(new CustomEvent("lql:submit"))
    }
    this.el.addEventListener("change", this._handleSearchControlChange)
    this.el.addEventListener("keydown", this._handleSearchControlKeydown)

    this.configureDateRangePicker()

    activateClipboardForSelector("#search-uri-query", {
      text: () => location.href,
    })
    $("#search-uri-query").tooltip()

    // Activate user idle tracking
    const idleInterval = $("#user-idle").data("user-idle-interval")
    idle({
      onIdle: () => {
        hook.pushEvent("soft_pause", {})
        console.log(
          `User idle for ${idleInterval}, live tail search stopped...`
        )
      },
      keepTracking: true,
      idle: idleInterval,
    }).start()

    setInterval(() => {
      const $lastQueryCompletedAt = $("#last-query-completed-at")
      const lastQueryCompletedAt = $lastQueryCompletedAt.attr("data-timestamp")
      if (lastQueryCompletedAt) {
        const elapsed = new Date().getTime() / 1000 - lastQueryCompletedAt
        $("#last-query-completed-at span").text(elapsed.toFixed(1))
      }
    }, 250);
  },
};

/* Listens for a `scrollIntoView` event on the element

  Example:

  <div phx-mounted={JS.dispatch("scrollIntoView")}>
    ...
  </div>
*/
hooks.ScrollIntoView = {
  mounted() {
    this.el.addEventListener("scrollIntoView", (event) => {
      event.target.scrollIntoView({ behavior: "instant" });
    });
  },
};

hooks.FormatTimestamps = {
  mounted() {
    applyToAllLogTimestamps(timestampNsToAgo);
  },

  updated() {
    applyToAllLogTimestamps(timestampNsToAgo);
  },
};

hooks.DocumentVisibility = {
  mounted() {
    this.handleVisibilityChange = () => {
      this.pushEvent("visibility_change", {
        visibility: document.visibilityState,
      });
    };
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  },

  destroyed() {
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange,
    );
  },
};

hooks.LiveTooltips = {
  mounted() {
    activateDelegatedTooltips(this.el, ".logflare-tooltip")
  },
  destroyed() {
    $(this.el).tooltip("dispose");
  },
};

export default hooks;
